var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main",class:{
    hide: _vm.system.hideSidebar === 1,
    mini: _vm.system.miniSidebar === 1,
  }},[_c('div',{staticClass:"sidebar"},[_c('Sidebar')],1),_c('div',{staticClass:"body"},[_c('BodyTop'),_c('BodyMain')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }